module.exports = __webpack_public_path__ + "static/img/MercadoPago.ac034ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MercadoPago.png
// module id = q4Ma
// module chunks = 1